import React from 'react';
import UnifiedMessageCustomerModal from './UnifiedMessageCustomerModal';
import { sendMessageToCustomers } from '../../../services/BackendService';
import { ICustomer } from '../types';

interface IProps {
  show: boolean;
  onClose: () => void;
  onCloseDiscardChanges: () => void;
  customer: ICustomer;
}

const MessageCustomerModal = ({ show, onClose, onCloseDiscardChanges, customer }: IProps) => {
  return (
    <UnifiedMessageCustomerModal
      show={show}
      onClose={onClose}
      onCloseDiscardChanges={onCloseDiscardChanges}
      customer={customer}
      titleKey="customer.send-message-to"
      successToastKey="customer.message-sent-to-customer"
      inputId="message"
      showSubject={true}
      useNumericId={true}
      onSend={({ customerId, message, subject }) => sendMessageToCustomers(customerId, message, subject || '')}
    />
  );
};

export default React.memo(MessageCustomerModal);
